export enum DocumentType {
    File = 1,
    URL = 2
}
